export default function reducer(state, { type, payload }) {
  switch (type) {
    case "SET_CHANGES":
      return {
        ...state,
        changes: payload,
      };
    case "SET_EDIT_ROW_KEY":
      return {
        ...state,
        editRowKey: payload,
      };
    default:
      return state;
  }
}
